export default "__VITE_ASSET__LahPo874__"